// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const DnsZoneDelegationStatusSchema = z.enum(['PENDING_VERIFICATION','VERIFIED','MISMATCH','UNVERIFIABLE'] as const);

export type DnsZoneDelegationStatusType = `${z.infer<typeof DnsZoneDelegationStatusSchema>}`

export default DnsZoneDelegationStatusSchema;
